import { sendHttpPostRequest } from '@/api/http-request'
import { checkIsTeacher } from '@/component/modal/login-register/login-register'
import { Button, Col, Modal, Progress, Row, message } from 'antd'
import Cookies from 'js-cookie'
import React, { useEffect, useRef, useState } from 'react'
import projectStyles from '../project.module.less'
import ExerciseCard from '@/pages/exercise/exercise-card'
import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'

interface Props {
  projectId: any
  setSelectedTabKey: any
  selectedTabKey: any
  testList: any[]
  setTestList: any
}
let globalCurrentExerciseId = 0

// 检测习题
export const ProjectTest: React.FC<Props> = (props: Props) => {
  const {
    testList,
    setTestList,
    projectId,
    setSelectedTabKey,
    selectedTabKey,
  } = props

  const currentExercise = useRef(null as any) //当前习题
  const [selecetedExerciseIndex, setSelecetedExerciseIndex] = useState(0) //默认选中第一题
  const [currentExerciseId, setCurrentExerciseId] = useState(testList[0] as any) //当前习题ID
  const [isSubmit, setIsSubmit] = useState(false)
  const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false)
  const [isPassModalVisible, setIsPassModalVisible] = useState(false)

  const [completeStatus, setCompleteStatus] = useState([] as any[])
  const [submissionResultList, setSubmissionResultList] = useState([] as any)

  const [passRate, setPassRate] = useState(0) // 通过率
  const [rightCount, setRightCount] = useState(0) // 通过的数量
  const [errorCount, setErrorCount] = useState(0) // 未通过的数量
  const [recommand, setRecommand] = useState('') // 提示信息
  const [wrongInfo, setWrongInfo] = useState([] as any[]) // 错题对应知识点
  const [resultPreviewStatus, setResultPreviewStatus] = useState(false)

  // 点击开始实训(12-01改成进入项目)
  const onStartProjectClick = () => {
    // setIsSubmit(false)
    setSelectedTabKey('3')
  }

  /** 答题状态和颜色的映射 */
  const getColorByStatus = (status: number) => {
    if (status == 0) {
      return '#f3f4f6'
    } else if (status == 1) {
      return '#10b981'
    } else if (status == 2) {
      return '#ef4444'
    }
  }

  /** 答题状态和题号颜色的映射 */
  const getFontColorByStatus = (status: number) => {
    if (status == 0) {
      return '#6b7280'
    } else {
      return '#fff'
    }
  }

  /** 选中题号和答题状态与题号颜色的映射 */
  const getBorderByStatus = (
    index: number,
    selecetedExerciseIndex: number,
    status: number
  ) => {
    if (index == selecetedExerciseIndex && status == 0) {
      return '2px solid #4f46e5'
    } else if (index == selecetedExerciseIndex && status == 1) {
      return '2px solid #4f46e5'
    } else if (index == selecetedExerciseIndex && status == 2) {
      return '2px solid #4f46e5'
    }
  }

  // 获取提交结果页信息

  const getSubmitResult = () => {
    let data = {
      project_id: projectId,
    }

    sendHttpPostRequest(
      'exercise/api/get_test_exercise_result',
      data,
      submitTestExeCallback
    )
  }

  // 确认交卷

  const handleSubmitOk = () => {
    submitAll()
    setIsSubmitModalVisible(false)
  }

  const submitTestExeCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      let info = response.data
      setSelecetedExerciseIndex(0)
      setPassRate(info.rate)
      setRightCount(info.right_count)
      setErrorCount(info.error_count)
      setRecommand(info.recommand)
      setWrongInfo(info.info)
      // setIsPassModalVisible(true)
    } else {
      message.error(response.msg)
    }
  }

  // 关闭提示弹窗

  const handleSubmitCancel = () => {
    setIsSubmitModalVisible(false)
    setIsPassModalVisible(false)
  }

  // 查询全部自测题提交情况
  const queryTestExerciseSubmission = () => {
    let data = {
      project_id: projectId,
    }
    sendHttpPostRequest(
      'exercise/api/test_exercise_submit_list',
      data,
      (res) => {
        if (res.code == 0) {
          setCompleteStatus(res.data.list)
          if (res.data.status == 2) {
            getSubmitResult()
            setSubmissionResultList(res.data.list)
            setIsSubmit(true)
            // 请求提交结果页面接口
          } else {
            setIsSubmit(false)
          }
        }
      }
    )

  }

  const queryTestExerciseSubmissionForPreview = () => {
    let data = {
      project_id: projectId,
    }
    sendHttpPostRequest(
      'exercise/api/test_exercise_submit_list',
      data,
      (res) => {
        if (res.code == 0) {
          setCompleteStatus(res.data.list)
          if (res.data.status == 2) {
            setSubmissionResultList(res.data.list)
            setIsSubmit(true)
            // 请求提交结果页面接口
          } else {
            setIsSubmit(false)
          }
        }
      }
    )
  }

  const queryExerciseCallback = (index, response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      currentExercise.current = response.data
      globalCurrentExerciseId = testList[index]
      if (isSubmit) {
        queryTestExerciseSubmissionForPreview()
      } else {
        queryTestExerciseSubmission()
      }
    } else {
      message.error(response.message)
    }
  }

  // 重新检测
  const onReTestClick = () => {
    setSelecetedExerciseIndex(0)
    clearSubmissionRecord()
    setIsSubmit(false)
    setResultPreviewStatus(false)
  }

  // 重新检测 清空原有提交记录
  const clearSubmissionRecord = () => {
    sendHttpPostRequest(
      'exercise/api/reset_test_exercise',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: projectId,
      },
      (response: any) => {
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          queryTestExerciseSubmission()
          queryExerciseInfo(0)
        }
      }
    )
  }

  useEffect(() => {
    queryExerciseInfo(0)
  }, [])

  // 查询习题详情
  const queryExerciseInfo = (index: any) => {
    let params = {
      exercise_id: testList[index],
      sessionid: Cookies.get('sessionid'),
      sid: Cookies.get('sessionid'),
      project_id: projectId,
      _key: selectedTabKey[0],
    }
    if (checkIsTeacher()) {
      params['mode'] = 2
    }
    sendHttpPostRequest(
      'exercise/api/get_test_exercise',
      params,
      queryExerciseCallback.bind(this, index)
    )
  }

  const submitAll = () => {
    let data = {
      project_id: projectId,
    }

    sendHttpPostRequest(
      'exercise/api/submit_test_exercise_all',
      data,
      (res) => {
        if (res.code == 0) {
          queryTestExerciseSubmission()
        }
      }
    )
  }

  const submitPractice = () => {
    try {
      document
        .getElementById(`test-exercise-run-${globalCurrentExerciseId}`)!
        .click()

      setTimeout(() => {
        queryTestExerciseSubmission()
      }, 200)
      setSelecetedExerciseIndex(testList?.length - 1)
      setCurrentExerciseId(testList[selecetedExerciseIndex])
      setIsSubmitModalVisible(true)
    } catch (e) {
      console.error(e)
    }
  }

  //未完成习题
  const notFinished = completeStatus.filter((value) => {
    return value == 0
  })

  /** 点击了下一题按钮 */
  const onNextExerciseBtnClick = () => {
    if (isSubmit) {
      selecetedExerciseIndex < testList?.length - 1
        ? queryExerciseInfo(selecetedExerciseIndex + 1)
        : queryExerciseInfo(0)
      selecetedExerciseIndex < testList?.length - 1
        ? setSelecetedExerciseIndex(selecetedExerciseIndex + 1)
        : setSelecetedExerciseIndex(0)
      setCurrentExerciseId(testList[selecetedExerciseIndex])
    } else {
      try {
        document
          .getElementById(`test-exercise-run-${globalCurrentExerciseId}`)!
          .click()
        selecetedExerciseIndex < testList?.length - 1
          ? queryExerciseInfo(selecetedExerciseIndex + 1)
          : queryExerciseInfo(0)
        selecetedExerciseIndex < testList?.length - 1
          ? setSelecetedExerciseIndex(selecetedExerciseIndex + 1)
          : setSelecetedExerciseIndex(0)
        setCurrentExerciseId(testList[selecetedExerciseIndex])
      } catch (e) {
        console.error(e)
      }
    }
  }

  /** 点击了上一题按钮 */
  const onPrevExerciseBtnClick = () => {
    if (isSubmit) {
      selecetedExerciseIndex < testList?.length
        ? queryExerciseInfo(selecetedExerciseIndex - 1)
        : queryExerciseInfo(testList?.length - 1)
      selecetedExerciseIndex < testList?.length
        ? setSelecetedExerciseIndex(selecetedExerciseIndex - 1)
        : setSelecetedExerciseIndex(testList?.length - 1)
      setCurrentExerciseId(testList[selecetedExerciseIndex])
    } else {
      try {
        document
          .getElementById(`test-exercise-run-${globalCurrentExerciseId}`)!
          .click()
  
        selecetedExerciseIndex < testList?.length
          ? queryExerciseInfo(selecetedExerciseIndex - 1)
          : queryExerciseInfo(testList?.length - 1)
        selecetedExerciseIndex < testList?.length
          ? setSelecetedExerciseIndex(selecetedExerciseIndex - 1)
          : setSelecetedExerciseIndex(testList?.length - 1)
        setCurrentExerciseId(testList[selecetedExerciseIndex])
  
      } catch (e) {
        console.error(e)
      }
    }
  }

  /** 点击了习题方块按钮 */
  const onExerciseBtnClick = (index) => {
    if (isSubmit) {
      setSelecetedExerciseIndex(index)
      setCurrentExerciseId(testList[selecetedExerciseIndex])

      queryExerciseInfo(index)
    } else {
      try {
        document
          .getElementById(`test-exercise-run-${globalCurrentExerciseId}`)!
          .click()
        setSelecetedExerciseIndex(index)
        setCurrentExerciseId(testList[selecetedExerciseIndex])

        queryExerciseInfo(index)
      } catch (e) {
        console.error(e)
      }
    }
  }


  const getSubmittedCount = ()=>{
     let submitted_count = 0
     completeStatus?.map((exercise)=>{
      if (exercise?.submit_info?.submit_status == 0){
        submitted_count = submitted_count + 1
      }
     })
     return 10 - submitted_count
  }


  const onResultExerciseBtnClick = (index) => {
    setResultPreviewStatus(true)
    setSelecetedExerciseIndex(index)
    setCurrentExerciseId(testList[index])
    queryExerciseInfo(index)
  }

  const handlePassOk = () => {
    setIsPassModalVisible(false)
    setIsSubmitModalVisible(false)
    //setIsCreateModalVisible(false);
    setIsSubmit(true)
  }
  // TODO: 如果没有全部提交，展示题目，如果全部提交，展示提交结果页面
  if (isSubmit == false || resultPreviewStatus) {
    return (
      <Row
        wrap={false}
        style={{
          minHeight:800,
        }}
      >
        <Col
          flex="auto"
          //className={projectStyles.aimDivWrapper}
          style={{
            minWidth: 400,
            position: 'relative',
            minHeight: '100%',


          }}
        >

          <div style={{padding:'16px 20px', color:'#3730a3', background:'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)', borderRadius:12, fontSize:15, marginBottom:28, border:'1px solid #c7d2fe', display:'flex', alignItems:'center', gap:12, lineHeight:1.6}}>
              <span style={{fontSize:20, flexShrink:0}}>📋</span>
              <span>在开始实训任务之前，请完成以下<strong>{testList?.length || 10}</strong>道检测题，帮助我们了解您对前置知识的掌握程度。完成所有题目后，系统将生成您的知识点诊断报告。</span>
          </div>

          <div style={{minHeight:650, borderRadius:12, background:'#fff', padding:24, boxShadow:'0 0 transparent, 0 0 transparent, 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1)'}}>
            <Row
              wrap={false}
              align={'middle'}
              style={{margin:'0 0 24px'}}
            >
              <Col span={12} style={{textAlign:'left'}}>
                <div>
                  <span style={{fontSize:14, color:'#4f46e5',fontWeight:500, background:'#4f46e51a', borderRadius:999, padding:'4px 12px'}}>第{selecetedExerciseIndex + 1}题 / 共{testList?.length}道</span>
                </div>
              
              </Col>

              <Col span={12} style={{textAlign:'right'}}>
                <div>
                  <span style={{fontSize:14, color:'#6b7280', background:'#f3f4f6', borderRadius:999, padding:'4px 12px'}}>{currentExercise.current?.knowledge}</span>
                </div>
              </Col>

            </Row>

            <div
              className={projectStyles.testWrapper}
              style={{
                minHeight: 500,
                height: 'calc(100vh - 420px)',
                overflowY: 'auto',
              }}
            >
              <ExerciseCard
                exercise={currentExercise.current}
                renderType="white"
                projectId={projectId}
                isSubmit={isSubmit}
                resultPreview={resultPreviewStatus}
              />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 12,
                marginTop: 20,
              }}
            >
              <Button
                style={{
                  borderRadius: 8, width: 88, height: 36, fontSize: 14,
                  color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                }}
                onClick={onPrevExerciseBtnClick}
                hidden={selecetedExerciseIndex == 0}
              >
                上一题
              </Button>
              <Button
                style={{
                  borderRadius: 8, width: 88, height: 36, fontSize: 14,
                  color: '#4f46e5', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe',
                }}
                onClick={onNextExerciseBtnClick}
                hidden={selecetedExerciseIndex == testList?.length - 1}
              >
                下一题
              </Button>
              {!resultPreviewStatus && !isSubmit && (
                <Button
                  type="primary"
                  style={{
                    borderRadius: 8, width: 88, height: 36, fontSize: 14,
                    backgroundColor: '#4f46e5',
                  }}
                  onClick={submitPractice}
                  hidden={selecetedExerciseIndex < testList?.length - 1}
                >
                  提交
                </Button>
              )}
            </div>

          </div>
        </Col>
        {/* 右侧题号题目面板 */}
        <Col
          flex="320px"
          style={{
            position: 'relative',
            minHeight: '100%',
            marginLeft:24,
          }}
          className={projectStyles.aimDivWrapper}
        >

          <div style={{
            padding: '14px 16px',
            borderRadius: 12,
            background: 'linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%)',
            border: '1px solid #e0e7ff',
            marginBottom: 16,
          }}>
            <Row wrap={false} align={'middle'}>
              <Col flex="auto">
                <div style={{fontSize: 14, fontWeight: 600, color: '#374151'}}>完成进度</div>
              </Col>
              <Col flex="80px" style={{textAlign:'right', paddingRight:4}}>
                <span style={{fontSize: 20, fontWeight: 700, color: '#4f46e5'}}>{getSubmittedCount()}<span style={{fontSize:13, fontWeight:400, color:'#9ca3af'}}>/{testList?.length || 10}</span></span>
              </Col>
            </Row>
            <div style={{marginTop: 8}}>
              <Progress showInfo={false} strokeColor='#4f46e5' trailColor={'#e0e7ff'} percent={getSubmittedCount() * 100 / (testList?.length || 10)} size="small" />
            </div>
          </div>

          <div style={{fontSize: 13, fontWeight: 600, color: '#6b7280', marginBottom: 10, letterSpacing: 1}}>习题状态</div>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 8,
              marginBottom: 24,
            }}
          >
            {completeStatus?.map((exercise: any, index: number) => (
              <div
                key={index}
                className={projectStyles.exerciseSquareBtn}
                style={{
                  backgroundColor: isSubmit
                    ? getColorByStatus(exercise.submit_info.result)
                    : getColorByStatus(exercise.submit_info.submit_status),
                  color: isSubmit
                    ? getFontColorByStatus(exercise.submit_info.result)
                    : getFontColorByStatus(exercise.submit_info.submit_status),
                  textAlign: 'center',
                  height: 36,
                  lineHeight: '36px',
                  width: 36,
                  fontSize: 15,
                  fontWeight: 600,
                  borderRadius: 8,
                  cursor: 'pointer',
                  border: isSubmit
                    ? getBorderByStatus(index, selecetedExerciseIndex, exercise.submit_info.result)
                    : getBorderByStatus(index, selecetedExerciseIndex, exercise.submit_info.submit_status),
                  transition: 'all 0.15s',
                }}
                onClick={() => { onExerciseBtnClick(index) }}
              >
                {index + 1}
              </div>
            ))}
          </div>
          <ModalDrag
            width={420}
            modalTitle={
              <div style={{ width: '100%', cursor: 'move', fontSize: 16, fontWeight: 600 }}>
                确认提交
              </div>
            }
            onCancel={handleSubmitCancel}
            onOk={handleSubmitOk}
            modalContent={
              <div style={{ textAlign: 'center', padding: '16px 0 8px' }}>
                {notFinished.length == 0 ? (
                  <div>
                    <div style={{fontSize:40, marginBottom:12}}>✅</div>
                    <div style={{fontSize:15, color:'#1e293b', fontWeight:500}}>已完成全部题目，确认提交吗？</div>
                  </div>
                ) : (
                  <div>
                    <div style={{fontSize:40, marginBottom:12}}>✋</div>
                    <div style={{fontSize:15, color:'#1e293b', fontWeight:500}}>还有 <span style={{color:'#f59e0b', fontWeight:700, fontSize:18}}>{notFinished.length}</span> 题未答</div>
                    <div style={{fontSize:13, color:'#94a3b8', marginTop:6}}>确认提交后将无法修改答案</div>
                  </div>
                )}
              </div>
            }
            open={isSubmitModalVisible}
          />

          <ModalDrag
            width={450}
            theme={'dark'}
            modalTitle={
              <div style={{ width: '100%', cursor: 'move', color: '#f2f2f2' }}>
                提示
              </div>
            }
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={handlePassOk}
                >
                  确认
                </Button>
              </div>
            }
            modalContent={
              <div
                style={{
                  margin: '0 auto',
                  textAlign: 'center',
                  width: 235,
                  color: '#f2f2f2',
                }}
              >
                <p>
                  正确率{' '}
                  <span style={{ color: '#4f46e5' }}>{passRate * 100}%</span>
                </p>
              </div>
            }
            open={isPassModalVisible}
          />
        </Col>
      </Row>
    )
  } else {
    return (
      <div className={projectStyles.submitDiv}>
        <div style={{display:'flex', gap:24, alignItems:'flex-start', flexWrap:'wrap'}}>

          {/* 左侧主内容 */}
          <div style={{flex:'1 1 480px', minWidth:0, display:'flex', flexDirection:'column', gap:16}}>

            {/* 成绩总览卡片 */}
            <div style={{
              background:'#fff', borderRadius:16, padding:'24px 28px',
              border:'1px solid #e5e7eb',
              boxShadow:'0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)',
              borderTop:'3px solid #4f46e5',
            }}>
              <div style={{fontSize:13, fontWeight:600, color:'#9ca3af', letterSpacing:1, textTransform:'uppercase', marginBottom:16}}>成绩总览</div>
              <div style={{display:'flex', alignItems:'stretch', gap:12, flexWrap:'wrap'}}>
                {/* 正确率 */}
                <div style={{
                  display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
                  padding:'16px 24px', background:'linear-gradient(135deg, #f5f3ff 0%, #eef2ff 100%)',
                  borderRadius:12, border:'1px solid #e0e7ff', flexShrink:0, minWidth:120,
                }}>
                  <div style={{fontSize:48, fontWeight:800, color:'#4f46e5', lineHeight:1}}>
                    {Math.round(passRate * 100)}<span style={{fontSize:20, fontWeight:600}}>%</span>
                  </div>
                  <div style={{fontSize:12, color:'#6b7280', marginTop:4}}>正确率</div>
                  <div style={{marginTop:10, width:'100%'}}>
                    <Progress percent={Math.round(passRate * 100)} showInfo={false} strokeColor='#4f46e5' trailColor='#e0e7ff' size="small" />
                  </div>
                </div>
                {/* 统计 */}
                <div style={{display:'flex', gap:10, flex:1, flexWrap:'wrap', alignItems:'stretch'}}>
                  <div style={{flex:'1 1 70px', borderRadius:12, padding:'14px 16px', textAlign:'center', background:'#f8fafc', border:'1px solid #e5e7eb', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                    <div style={{fontSize:11, fontWeight:600, color:'#9ca3af', letterSpacing:1, marginBottom:6}}>总题数</div>
                    <div style={{fontSize:30, fontWeight:700, color:'#1e293b', lineHeight:1}}>{testList?.length}</div>
                  </div>
                  <div style={{flex:'1 1 70px', borderRadius:12, padding:'14px 16px', textAlign:'center', background:'#f0fdf4', border:'1px solid #bbf7d0', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                    <div style={{fontSize:11, fontWeight:600, color:'#4ade80', letterSpacing:1, marginBottom:6}}>答对</div>
                    <div style={{fontSize:30, fontWeight:700, color:'#16a34a', lineHeight:1}}>{rightCount}</div>
                  </div>
                  <div style={{flex:'1 1 70px', borderRadius:12, padding:'14px 16px', textAlign:'center', background:'#fef2f2', border:'1px solid #fecaca', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                    <div style={{fontSize:11, fontWeight:600, color:'#f87171', letterSpacing:1, marginBottom:6}}>答错</div>
                    <div style={{fontSize:30, fontWeight:700, color:'#dc2626', lineHeight:1}}>{errorCount}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* 诊断报告 */}
            {(recommand || wrongInfo?.length > 0) && (
              <div style={{
                background:'#fff', borderRadius:16, padding:'20px 24px',
                border:'1px solid #e5e7eb',
                boxShadow:'0 1px 3px rgba(0,0,0,0.06)',
                borderLeft:'3px solid #f59e0b',
              }}>
                <div style={{fontSize:13, fontWeight:600, color:'#9ca3af', letterSpacing:1, textTransform:'uppercase', marginBottom:14}}>知识点诊断</div>
                {recommand && (
                  <div style={{
                    fontSize:14, color:'#92400e', background:'#fffbeb', borderRadius:8,
                    padding:'10px 14px', marginBottom:14, border:'1px solid #fde68a', lineHeight:1.7,
                  }}>{recommand}</div>
                )}
                {wrongInfo?.length > 0 && (
                  <div style={{display:'flex', flexDirection:'column', gap:6}}>
                    {wrongInfo.map((knowledge: any, index: number) => (
                      <div key={index} style={{
                        display:'flex', alignItems:'center', gap:10, fontSize:14, color:'#374151',
                        padding:'8px 12px', borderRadius:8, background:'#f9fafb', border:'1px solid #f3f4f6',
                      }}>
                        <span style={{width:6, height:6, borderRadius:'50%', background:'#f59e0b', flexShrink:0}}></span>
                        <span style={{color:'#6b7280', fontSize:12, flexShrink:0}}>知识点</span>
                        <span style={{fontWeight:500}}>{knowledge}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* 右侧：答题详情 + 操作 */}
          <div style={{width:280, flexShrink:0, display:'flex', flexDirection:'column', gap:16}}>

            {/* 答题详情题号 */}
            <div style={{
              background:'#fff', borderRadius:16, padding:'20px',
              border:'1px solid #e5e7eb',
              boxShadow:'0 1px 3px rgba(0,0,0,0.06)',
            }}>
              <div style={{fontSize:13, fontWeight:600, color:'#9ca3af', letterSpacing:1, textTransform:'uppercase', marginBottom:14}}>答题详情</div>
              <div style={{display:'flex', flexWrap:'wrap', gap:8}}>
                {submissionResultList?.map((exercise: any, index: number) => {
                  const isWrong = exercise.submit_info.result == 0 || exercise.submit_info.result == 2
                  return (
                    <div
                      key={index}
                      className={projectStyles.exerciseSquareBtn}
                      style={{
                        backgroundColor: isWrong ? '#fef2f2' : '#f0fdf4',
                        color: isWrong ? '#dc2626' : '#16a34a',
                        border: isWrong ? '1px solid #fecaca' : '1px solid #bbf7d0',
                        textAlign:'center', height:36, lineHeight:'36px', width:36,
                        fontSize:14, fontWeight:600, borderRadius:8, cursor:'pointer',
                        transition:'all 0.15s',
                      }}
                      onClick={() => { onResultExerciseBtnClick(index) }}
                    >
                      {index + 1}
                    </div>
                  )
                })}
              </div>
              <div style={{display:'flex', gap:12, marginTop:14, fontSize:12, color:'#6b7280'}}>
                <span style={{display:'flex', alignItems:'center', gap:4}}>
                  <span style={{width:8, height:8, borderRadius:2, background:'#f0fdf4', border:'1px solid #bbf7d0', display:'inline-block'}}></span>答对
                </span>
                <span style={{display:'flex', alignItems:'center', gap:4}}>
                  <span style={{width:8, height:8, borderRadius:2, background:'#fef2f2', border:'1px solid #fecaca', display:'inline-block'}}></span>答错
                </span>
              </div>
            </div>

            {/* 操作按钮 */}
            <div style={{display:'flex', flexDirection:'column', gap:10}}>
              <Button
                onClick={onStartProjectClick}
                type="primary"
                block
                style={{height:42, borderRadius:10, fontSize:14, fontWeight:600, backgroundColor:'#4f46e5', borderColor:'#4f46e5'}}
              >
                进入项目
              </Button>
              <Button
                onClick={onReTestClick}
                block
                style={{height:42, borderRadius:10, fontSize:14, fontWeight:500, borderColor:'#e5e7eb', color:'#6b7280'}}
              >
                重新检测
              </Button>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
